<template>
  <div style="padding: 0 10px">
    <ScanQuery @onQuery="queryCall" ph="输入快递单号">
      <template slot="customize">
        <el-button type="primary" @click="allReceipt">批量签收</el-button>
      </template>
    </ScanQuery>
    <div style="display:flex">
      <div :class="[{receiptFlag:systemSource},'card']">{{ systemSource?systemSource:'D2C/B2B' }}</div>
      <div :class="[{receiptFlag:!checkingFlag},'card']">无需质检</div>
    </div>
    <WmsTable :is-pagination="false" :columns="columns" :dataSource="dataSource" :hasHeader="false">
      <template slot="weightAction" slot-scope="{ text, record, index }">
        <IptNumber unit="kg" v-model="record.weight" />
      </template>
      <template slot="boxAmountAction" slot-scope="{ text, record, index }">
        <IptNumber unit="箱" v-model="record.boxAmount" />
      </template>
      <template slot="remarkAction" slot-scope="{ text, record, index }">
        <el-input maxlength='450' type="textarea" v-model="record.remark" placeholder="备注" />
      </template>
      <div slot="action" slot-scope="{ text, record, index }"
        style="display: flex; justify-content: space-between; align-items: center">
        <!-- <a href="javascript:;" @click="submitReceipt(record)"> 确认签收</a> -->
        <!--        只有采购单类型的才有异常登记 start-->
        <!--        只有采购单类型的才有异常登记 start-->
        <!--        只有采购单类型的才有异常登记 start-->
        <!-- <a
          href="javascript:;"
          @click="abnormalHandler(record)"
          v-if="!record.purchaseNo"
        >
          异常登记</a
        > -->
        <el-button type="text" @click="abnormalHandler(record)" v-if="record.status == 99"> 异常登记</el-button>
        <!--        只有采购单类型的才有异常登记 end-->
        <!--        只有采购单类型的才有异常登记 end-->
        <!--        只有采购单类型的才有异常登记 end-->
        <a href="javascript:;" @click="removeRecord(index)"> 移除</a>
      </div>
    </WmsTable>
    <el-dialog title="异常处理" width="1400px" :visible.sync="abnormalInfo.visible" :show-close="false"
      :confirm-loading="abnormalInfo.loading" @close="handleCancel" :footer="null" ref="isreceipt">
      <el-card v-if="abnormalInfo.visible">
        <Content :abnormal-type="abnormalInfo.types" :uploadId="abnormalInfo.expressNo" btnTitle="异常上报采购"
          @submitAbnormal="abnormalCall" :isreceipt="true" abnormal="Purchase" ref="content" />
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import { receiptColumns, testDataSource } from "@/views/inHouse/receiptData";
import IptNumber from "@/components/IptNumber";
import { audioPay } from "@/utils/tools";
import Calendar from "@/utils/calendar";
import Content from "@/views/inHouse/components/Abnormal/Content";
import { abnormalPurchase } from "@/types";
import { signQuery, signSubmit, createSignFlow, imgByCode } from "@/apis/inHouse";

export default {
  title: "签收",
  name: "Receipt",
  components: {
    // [Modal.name]: Modal,
    Content,
    ScanQuery,
    IptNumber,
    WmsTable,
  },
  data() {
    return {
      query: {
        code: "",
        // current: 1,
        // pageSize: 10,
        // total: 0
      },
      columns: receiptColumns,
      dataSource: [],
      abnormalInfo: {
        visible: false,
        loading: false,
        types: abnormalPurchase.slice(0, 1),
        data: null,
        expressNo: "",
      },
      checkingFlag:true,
      systemSource:''
    };
  },
  methods: {
    queryCall: function (payload) {
      this.query.code = payload.code;
      if (!this.query.code) return;
      this.getDataSource();
    },
    getDataSource: function () {
      const that = this;
      const _isScan = this.dataSource.some((item) => item.expressNo === that.query.code);
      if (_isScan) {
        this.$message.warning("快递单号已存在，请勿重复扫描！");
        return;
      }
      that.checkingFlag = true
      that.systemSource = ''
      signQuery({ expressNo: that.query.code }).then(({ code, data }) => {
        if (code === 0) {
          // const noUpdate = data.purchaseOrderRespDTOList.every((item)=>this.dataSource.some(d=>d.expressNo == item.expressNo))
          // if(noUpdate){
          //   this.$message.warning("快递单号已存在，请勿重复扫描！");
          //   return;
          // }
          if(data.purchaseOrderRespDTOList.some(v => v.systemSource != data.purchaseOrderRespDTOList[0].systemSource)){
            this.$message.error('系统来源数据错误，请联系管理员处理')
            return
          }
          let status = data.purchaseOrderRespDTOList && data.purchaseOrderRespDTOList[0].purchaseNo ? 1 : data.transferWarehouseDelivery ? 2 : 99 //1普通物流单 2调拨单 99异常单
          that.checkingFlag = data.purchaseOrderRespDTOList.some(v => v.checkingFlag)
          let systemSourceDesc = data.purchaseOrderRespDTOList[0].systemSource
          that.systemSource = systemSourceDesc ==  1 ?'D2C':systemSourceDesc ==  2?'B2B':''
          let arr = data.purchaseOrderRespDTOList.map(item => {
            let { remark } = item;
            return {
              remark: remark || '',
              ...item,
              expressNo: item.expressNo,
              weight: 0,
              boxAmount: 0,
              status: status
            }
          }).filter(item=>!this.dataSource.some(d=>d.expressNo == item.expressNo))
          this.dataSource = [...arr, ...this.dataSource];
          if(data.purchaseOrderRespDTO.broadcastFlag) {
            setTimeout(() => {
              audioPay(`包裹中有沼田货物，请注意区分`)
            }, 1500)
          }
          status == 99 && audioPay(`采购单缺失`);
          status == 1 && audioPay(`完成`);
          status == 2 && audioPay(`完成仓库调拨件`);
        }
      });
    },
    // 移除
    removeRecord: function (index) {
      const that = this;
      this.$confirm("确定删除该快递单号？", "移除提示", {
        confirmButtonText: "删除",
        type: "warning",
        cancelButtonText: "取消",
      }).then(() => {
        that.dataSource.splice(index, 1);
      });
    },
    // 签收异常处理 start
    // 签收异常处理 start
    // 签收异常处理 start
    handleCancel: function () {
      this.abnormalInfo.visible = false;
    },
    abnormalHandler: function (record) {
      // if(this.abnormalInfo.expressNo == record.expressNo){
      //   this.$refs.content
      // }
      this.abnormalInfo.visible = true;
      // this.abnormalInfo.data = record;
      this.abnormalInfo.expressNo = record.expressNo;
    },
    abnormalCall: function (payload) {

      // return
      if (payload.expressPhone == "") {
        this.$message.warning("请输入手机号");
        return false;
      }
      let params = {
        expressNo: payload.qrCode,
        expressPhone: payload.expressPhone,
        remark: payload.textarea,
      };
      imgByCode({ picRelation: payload.qrCode }).then(({ code, data }) => {
        if (code === 0) {
          if (data.length > 0) {
            createSignFlow(params).then(({ code, data }) => {
              console.log(params);
              if (code === 0) {
                this.$message.success("成功");
                this.handleCancel();
              }
            });
          } else {
            this.$message.warning("请先上传图片");
          }
        }
      });
      // return;
      // todo http
      // ...
      // setTimeout((_) => {
      //   this.$message.success("上报成功！");
      //   this.abnormalInfo.visible = false;
      // }, 500);
    },
    // 签收异常处理 end
    // 签收异常处理 end
    // 签收异常处理 end
    // todo 确认签收
    submitReceipt: function (r) {
      const that = this;
      let data = { ...r };
      data.weight = data.weight * 1000;
      signSubmit([r]).then(({ code, data }) => {
        if (code === 0) {
          that.$message.success("签收成功");
          that.dataSource = that.dataSource.filter((item) => item.expressNo !== r.expressNo);
        }
      });
    },
    allReceipt: function () {
      let arrCache = this.dataSource.map((item) => {
        return {
          expressNo: item.expressNo,
          weight: item.weight * 1000,
          boxAmount: item.boxAmount,
          // createTime: item.createTime,
          purchaseNo: item.purchaseNo,
          remark: item.remark,
          signType: item.status,
          systemSource: item.systemSource,
          warehouse: item.wareCode
        }
      })
      signSubmit(arrCache).then(({ code, data }) => {
        if (code === 0) {
          this.checkingFlag = true
          this.systemSource = ''
          this.dataSource = [];
          this.$message.success("签收成功");
        }
      });
    },
  },
};
</script>

<style scoped>

.card{
  height: 100px;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ddeeff;
  color: #c9d8e8;
  font-size: 26px;
  margin: 10px;
}
.receiptFlag{
  color:red
}

</style>
